export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <p>© {new Date().getFullYear()} Jon Woodring · Agentic Solutions.</p>
      </div>
    </footer>
  );
}
